export const EmptyActivity = {
  marketoName: null,
  marketoId: null,
  activityType: null
}

export const DriftActivityType = {
  SYNC_CONVERSATIONS: 'SYNC_CONVERSATIONS',
  SYNC_MEETINGS: 'SYNC_MEETINGS',
  SYNC_CQL_SCORE: 'SYNC_CQL_SCORE'
}



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/MarketoIntegrationPage/constants.js